import Branch from 'branch-sdk';
export { default } from 'branch-sdk';

/* eslint-disable @typescript-eslint/no-explicit-any */
var ua = "".concat(window.navigator.userAgent || navigator.vendor || window.opera || '').toLowerCase();
var branchSessionDataKey = "branch_data-".concat(Date.now());
var BranchSessionData = function (branchIOConfig) {
    return new Promise(function (resolve, reject) {
        if (window[branchSessionDataKey]) {
            resolve(window[branchSessionDataKey]);
            return;
        }
        var branchKey = branchIOConfig.branchKey;
        if (!branchKey || branchKey === '') {
            console.warn("Couldn't determine branchIO api key. Not initializing branch.io");
            return;
        }
        Branch.init(branchKey, { retries: 3, retry_delay: 20 }, function (err, data) {
            if (err) {
                reject(err);
            }
            else {
                window[branchSessionDataKey] = data;
                resolve(data);
            }
        });
    });
};
var isInstagramBrowser = function () {
    return ua.indexOf('instagram') >= 0;
};
var isFaceBookBrowser = function () {
    return ua.indexOf('fban') >= 0 || ua.indexOf('fbav') >= 0;
};
var isInstagramOrFBBrowser = function () {
    return isInstagramBrowser() || isFaceBookBrowser() ? true : false;
};
var setupDeepView = function (trackingData) {
    return new Promise(function (resolve, reject) {
        return Branch.deepview({
            data: trackingData,
        }, {}, function (e) {
            if (e) {
                reject(e);
            }
            else {
                resolve();
            }
        });
    });
};
var runDeepViewCTA = function () {
    Branch.deepviewCta();
};

export { BranchSessionData, isFaceBookBrowser, isInstagramBrowser, isInstagramOrFBBrowser, runDeepViewCTA, setupDeepView, ua };
//# sourceMappingURL=Branch.js.map
